import { useRef, useEffect, useState } from "react";
import { getActiveState, preloadImg } from "../helpers/titreHelper";
import { useGetParams } from "./useGetParams";
import { useInterval } from "./useInterval";
import { v4 as uuidv4 } from "uuid";

export const useBroadcastPhoto = () => {
  const { user, carousel, repeatCount, startFrom, duration } = useGetParams();
  const [currentState, setCurrentState] = useState(null);
  const [isVisible, setIsVisible] = useState(null);
  const [showedMessages, setShowedMessages] = useState([]);

  const lastMessageIdRef = useRef(0);
  const nextMessageIndexRef = useRef(-1);
  const messagesRef = useRef([]);
  const currentMessageRef = useRef(null);

  const getBroadcastInfo = async () => {
    try {
      const response = await fetch(
        `http://api.stream.iactive.pro/titreInfo?user=${user}&from=${lastMessageIdRef.current}&type=1`
      );
      const data = await response.json();
      if (!data) return;
      let { messagesList, deletedMessagesIdList, visibility } = data;

      // Определяем видимость титра

      if (!visibility && visibility !== isVisible) {
        setIsVisible(false);
        return;
      } else if (visibility && visibility !== isVisible) {
        setIsVisible(true);
      }

      // Определяем состояние (S1, S2 ...)

      if (
        data?.statusList[0]?.state &&
        getActiveState(data?.statusList[0]?.state) !== currentState
      ) {
        setCurrentState(getActiveState(data?.statusList[0].state));
      }

      // Удаляем сообщения по команде пользователя
      if (showedMessages.some((item) => deletedMessagesIdList.includes(Number(item.id)))) {
        setShowedMessages(
          showedMessages.filter((item) => !deletedMessagesIdList.includes(Number(item.id)))
        );
      }
      // если список сообщений не пустой

      if (Array.isArray(messagesList) && messagesList.length === 0) {
        // если имеются в списке сообщений удаленные
        if (messagesRef.current.some((el) => deletedMessagesIdList.includes(+el.id))) {
          const newState = messagesRef.current.filter(
            (el) => !deletedMessagesIdList.includes(+el.id)
          );

          for (let i = 0; i < messagesRef.current.length; i++) {
            if (
              !newState.find(
                (el) =>
                  nextMessageIndexRef.current &&
                  el.id === messagesRef.current[nextMessageIndexRef.current]?.id
              )
            ) {
              if (
                messagesRef.current[nextMessageIndexRef.current] ===
                messagesRef.current[messagesRef.current.length - 1]
              ) {
                nextMessageIndexRef.current--;
                if (nextMessageIndexRef.current < 0) nextMessageIndexRef.current = 0;
              }
            }
            if (
              i < nextMessageIndexRef.current &&
              !newState.find((el) => el.id === messagesRef.current[i].id)
            ) {
              nextMessageIndexRef.current--;
              if (nextMessageIndexRef.current < 0) nextMessageIndexRef.current = 0;
            }
          }
          messagesRef.current = newState;
        }
        return;
      }
      // Удаляем сообщения, если они не содержат текста или картинки.
      messagesList = messagesList.filter(
        (el) =>
          !(
            Array.isArray(el.message.attachments) &&
            el.message.attachments.length > 0 &&
            typeof el.message.attachments[0] === "object" &&
            el.message.attachments[0].type === "audio_msg" &&
            el.message.content === ""
          )
      );

      // const messagesRepeatCount = lastMessageIdRef.current === "0" ? repeatCount : null;

      //запоминаем id последнего сообщения, для дальнейших запросов
      lastMessageIdRef.current = messagesList[0]?.id || lastMessageIdRef.current;

      let result = [...messagesRef.current, ...messagesList.reverse()].filter(
        (item) => item.message.attachments[0]?.type === "image" && item.titrTag === "F2"
      );

      messagesRef.current = result;
    } catch (error) {
      console.error(error);
    }
  };

  const iterateIndex = (array) => {
    if (carousel === "1") {
      if (!array.length) {
        nextMessageIndexRef.current = -1;
        return;
      }
      if (nextMessageIndexRef.current < array.length - 1) {
        nextMessageIndexRef.current++;
      } else {
        if (messagesRef.current.length >= startFrom) {
          messagesRef.current = messagesRef.current.slice(-repeatCount);
          nextMessageIndexRef.current = 0;
        }
      }
    } else {
      if (nextMessageIndexRef.current < messagesRef.current.length - 1)
        nextMessageIndexRef.current++;
      else {
        nextMessageIndexRef.current = messagesRef.current.length - 1;
      }
    }
  };

  const updateShowedMessages = (newMessages) => {
    if (newMessages && messagesRef.current.length >= startFrom) {
      currentMessageRef.current = newMessages;

      const newMessagesWithUUID = {
        ...newMessages,
        UUID: uuidv4(),
      };
      const newMessagesArr = [newMessagesWithUUID];
      setShowedMessages(newMessagesArr);
    }
  };

  useEffect(() => {
    getBroadcastInfo().then(() => {
      if (messagesRef.current && messagesRef.current.length > 0) {
        iterateIndex(messagesRef.current);
        updateShowedMessages(messagesRef.current[nextMessageIndexRef.current]);
      }
    });
  }, []);

  // Выбор сообщения для показа
  useInterval(() => {
    iterateIndex(messagesRef.current);
    if (
      !messagesRef.current[nextMessageIndexRef.current]?.id ||
      (showedMessages.some((el) => el.id === messagesRef.current[nextMessageIndexRef.current].id) &&
        carousel === "0")
    ) {
      return;
    } else if (carousel === "1" && messagesRef.current.length < startFrom) {
      return;
    } else {
      updateShowedMessages(messagesRef.current[nextMessageIndexRef.current]);
    }
  }, duration);

  // Получение информации о титре
  useInterval(getBroadcastInfo, 5000);

  return {
    currentState,
    isVisible,
    showedMessages,
  };
};
